// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__RDI6i","label":"Labeled_label__1WX_D","divider":"Labeled_divider__2_gzn"};